import React, { useState, useEffect } from 'react'
import InputField from '../../CommonComponents/InputMUI'
import PiePage from '../../CommonComponents/PiePage.component'
import Loader from '../../../../../presentationals/Loader/Loader.component';
import Popup from '../../../../../presentationals/Popup/Popup.component';
import CheckBoxField from '../../CommonComponents/CheckboxMUI'
import SelectField from '../../CommonComponents/SelectMUI';
import { SaveUpdateNpaWeightage, UpdateNPaWightageBYUUID } from '../Actioncreator';

const vehicleTypeData = [
    { name: "L3", code: 'L3' },
    { name: "L5", code: 'L5' },
]

const NumericObj = {
    "minValue": null,
    "maxValue": null,
    "minRange": null,
    "maxRange": null,
    "vehicleType": null,
    "weightage": null,
    "npa": null
};

const TextObj = {
    "subParam": null,
    "weightage": null,
    "npa": null
}

const handleInitalObj = (data) => {
    if (Object.keys(data)?.length > 0) {
        if (data?.type == "NUMERIC") {
            return NumericObj
        } else {
            return TextObj
        }
    }
}

export default function Add({ handleType, Detaildata }) {
    console.log("detail", Detaildata)
    const [loader, setLoader] = useState(false)
    const [popupState, setpopupState] = useState({ show: false, popupStatus: "" })
    const [objectData, setObjectData] = useState(handleInitalObj(Detaildata))


    useEffect(() => {
        if (Detaildata?.type == "NUMERIC") {
            if (Detaildata?.uuid) {
                setObjectData({
                    "minValue": Detaildata?.minValue ?? null,
                    "maxValue": Detaildata?.maxValue ?? null,
                    "minRange": Detaildata?.minRange ?? null,
                    "maxRange": Detaildata?.maxRange ?? null,
                    "vehicleType": Detaildata?.vehicleType ?? null,
                    "weightage": Detaildata?.weightage ?? null,
                    "npa": Detaildata?.npa ?? null
                })
            } else {
                setObjectData({
                    "minValue": null,
                    "maxValue": null,
                    "minRange": null,
                    "maxRange": null,
                    "vehicleType": null,
                    "weightage": null,
                    "npa": null
                })
            }
        } else if (Detaildata?.type == "TEXT" || Detaildata?.type == "OEM" || Detaildata?.type == "DEALER") {
            if (Detaildata?.id) {
                setObjectData({
                    subParam: Detaildata?.subParam ?? null,
                    "weightage": Detaildata?.weightage ?? null,
                    "npa": Detaildata?.npa ?? null
                })
            } else {
                setObjectData({
                    "subParam": null,
                    "weightage": null,
                    "npa": null

                })
            }
        }
    }, [Detaildata])

    const inputChange = (e, type) => {
        const changeObj = Object.assign({}, objectData);
        changeObj[type] = e

        setObjectData(changeObj)
    }

    const saveHandler = () => {
        if (Detaildata?.uuid) {
            const obj = { ...objectData, creditParamId: Detaildata?.creditParamId, uuid: Detaildata?.uuid }
            setLoader(true)
            UpdateNPaWightageBYUUID(obj, callback => {
                console.log("cal", callback)
                setLoader(false)
                if (callback && callback?.message == "success") {
                    setpopupState({ show: true, popupStatus: "Data Updated Successfully" })
                } else {
                    setpopupState({ show: true, popupStatus: "Error Updating Category" })
                }
                removePopup()
            })
        } else {
            const obj = { ...objectData, creditParamId: Detaildata?.creditParamId }
            setLoader(true)
            SaveUpdateNpaWeightage(obj, callback => {
                console.log("cal", callback)
                setLoader(false)
                if (callback && callback?.message == "success") {
                    setpopupState({ show: true, popupStatus: "Data Saved Successfully" })
                } else {
                    setpopupState({ show: true, popupStatus: "Error Saving Category" })
                }
                removePopup()
            })

        }
    }

    const closePopup = () => {
        setpopupState({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => { closePopup() }, 5000)
    }


    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popupState.show ? <Popup popupStatus={popupState?.popupStatus} closePopup={closePopup} /> : ''
            }

            <div className="communitySection" style={{ marginTop: '50px' }}>
                <div className='container hoverNone card'>
                    <PiePage
                        totalPage={1}
                        currentPage={1}
                        heading={'Add BRE Configurations'}
                    />


                    {
                        Detaildata?.type === "TEXT" || Detaildata?.type == "OEM" || Detaildata?.type == "DEALER" ?
                            <div className="row" style={{ marginBottom: '12px' }}>
                                <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                    <InputField
                                        label="Sub-Category Name"
                                        variant="outlined"
                                        value={objectData?.subParam}
                                        name="subParam"
                                        id="subParam"
                                        type="text"
                                        onChange={e => inputChange(e, "subParam")}
                                        size="small"
                                    // required={true}
                                    />
                                </div>
                                <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                    <InputField
                                        label="weightage"
                                        variant="outlined"
                                        value={objectData?.weightage}
                                        name="weightage"
                                        id="weightage"
                                        type="number"
                                        onChange={e => inputChange(e, "weightage")}
                                        size="small"
                                    // required={true}
                                    />
                                </div>
                                <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                    <InputField
                                        label="NPA"
                                        variant="outlined"
                                        value={objectData?.npa}
                                        name="npa"
                                        id="npa"
                                        type="number"
                                        onChange={e => inputChange(e, "npa")}
                                        size="small"
                                    // required={true}
                                    />
                                </div>
                            </div>
                            : ''}

                    {
                        Detaildata?.type == "NUMERIC" ?
                            <>
                                <div className="row" style={{ marginBottom: '12px' }}>

                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <InputField
                                            label="Min Value"
                                            variant="outlined"
                                            value={objectData?.minValue}
                                            name="minValue"
                                            id="minValue"
                                            type="number"
                                            onChange={e => inputChange(e, "minValue")}
                                            size="small"
                                        // required={true}
                                        />
                                    </div>

                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <InputField
                                            label="Max Value"
                                            variant="outlined"
                                            value={objectData?.maxValue}
                                            name="maxValue"
                                            id="maxValue"
                                            type="number"
                                            onChange={e => inputChange(e, "maxValue")}
                                            size="small"
                                        // required={true}
                                        />
                                    </div>

                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <SelectField
                                            value={objectData.vehicleType}
                                            label="Vehicle Type"
                                            onChange={e => inputChange(e, 'vehicleType')}
                                            name="vehicleType"
                                            id="vehicleType"
                                            data={vehicleTypeData}
                                            size={'small'}

                                        />
                                    </div>

                                </div>
                                <div className="row" style={{ marginBottom: '12px' }}   >
                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <InputField
                                            label="Min Range"
                                            variant="outlined"
                                            value={objectData?.minRange}
                                            name="minRange"
                                            id="minRange"
                                            type="number"
                                            onChange={e => inputChange(e, "minRange")}
                                            size="small"
                                        // required={true}
                                        />
                                    </div>
                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <InputField
                                            label="Max Range"
                                            variant="outlined"
                                            value={objectData?.maxRange}
                                            name="maxRange"
                                            id="maxRange"
                                            type="number"
                                            onChange={e => inputChange(e, "maxRange")}
                                            size="small"
                                        // required={true}
                                        />
                                    </div>

                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <InputField
                                            label="weightage"
                                            variant="outlined"
                                            value={objectData?.weightage}
                                            name="weightage"
                                            id="weightage"
                                            type="number"
                                            onChange={e => inputChange(e, "weightage")}
                                            size="small"
                                        // required={true}
                                        />
                                    </div>

                                </div>
                                <div className="row" style={{ marginBottom: '12px' }}>
                                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                                        <InputField
                                            label="NPA"
                                            variant="outlined"
                                            value={objectData?.npa}
                                            name="npa"
                                            id="npa"
                                            type="number"
                                            onChange={e => inputChange(e, "npa")}
                                            size="small"
                                        // required={true}
                                        />
                                    </div>
                                </div>
                            </>
                            : ''}



                    <div className='mb-3 mt-2 row' style={{ margin: '20px 0 15px 0' }}>

                        <div className="col-12 text-center">

                            <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler(e)}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
